export interface EventStyles {
  colors: EventColorScheme;
  fontFamily: string;
}


export interface EventStyleColors {
  primary: string;
  dark: string;
  darker: string;
  light: string;
  lighter: string;
}

/**
 * The full palette applied to / stored for an event page: the legacy five values
 * plus a page background and a derived Register-button label color. The two new
 * fields are optional so events saved before this feature hydrate cleanly
 * (absent → Mode A / today's behavior).
 */
export interface EventColorScheme extends EventStyleColors {
  background?: string | null;
  buttonTextColor?: string;
}

/**
 * The two colors a user actually picks.
 *
 * `contentColor` is whatever the page text currently uses — the user's brand color in Mode A, the
 * background-derived text in Mode B (decision D7). It is also the only hue a greyscale background may
 * borrow for its accent, because it is the colour the styles panel is showing.
 */
export interface EventColorInputs {
  background: string | null;
  contentColor: string;
}

/** Which Mode-A palette generator drives the single-color case. */
export enum StyleVariant {
  CLASSIC = 'classic',
  BALANCED = 'balanced',
}
